export default __webpack_public_path__ + "static/media/frg--outdoor-lagoon-pool.51399979.png";